import React from 'react';
const organs = [{
  icon: '🫀',
  name: 'Corazón y arterias',
  desc: 'Las endurece gradualmente'
}, {
  icon: '🫘',
  name: 'Riñones',
  desc: 'Daña los filtros microscópicos'
}, {
  icon: '👁️',
  name: 'Ojos',
  desc: 'Afecta las proteínas del cristalino'
}, {
  icon: '⚡',
  name: 'Sistema nervioso',
  desc: 'Daña fibras que transmiten señales'
}, {
  icon: '🦴',
  name: 'Articulaciones',
  desc: 'Rigidiza el colágeno que las sostiene'
}];
export function Mechanism() {
  return <section className="py-20 md:py-28 px-4 bg-dark-primary" data-id="element-455">
      <div className="max-w-content mx-auto" data-id="element-456">
        <div className="text-center mb-12" data-id="element-457">
          <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em] mb-4" data-id="element-458">
            LA CIENCIA EXPLICADA
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-cream leading-tight max-w-3xl mx-auto" data-id="element-459">
            Hay un proceso que lleva décadas estudiándose — y que la mayoría
            nunca escucha nombrar hasta que algo ya cambió
          </h2>
        </div>

        <div className="space-y-6 font-sans text-gray-warm text-[17px] md:text-[18px] leading-relaxed max-w-2xl mx-auto mb-16 text-center md:text-left" data-id="element-460">
          <p data-id="element-461">
            Hay un proceso que ocurre en silencio dentro de tu cuerpo. No duele.
            No avisa. No genera señales claras. La vida sigue con normalidad
            mientras un proceso silencioso comienza a dejar pequeñas huellas que
            la mayoría de las personas ni siquiera sabe que existen.
          </p>
          <p data-id="element-462">
            Se llama glicación. Sucede cuando el exceso de azúcar comienza a
            'pegarse' a partes importantes de tus células y con el tiempo puede
            afectar lentamente arterias, corazón, riñones, ojos, piel y nervios.
            Todo en silencio, mientras muchas personas creen que todo está bien.
          </p>
        </div>

        {/* Callout Box */}
        <div className="bg-gold/5 border border-gold rounded-lg p-8 md:p-12 text-center mb-16 relative overflow-hidden" data-id="element-463">
          <div className="absolute inset-0 bg-gradient-to-b from-gold/5 to-transparent pointer-events-none" data-id="element-464"></div>
          <span className="relative z-10 block font-mono text-[12px] text-gold uppercase tracking-[0.2em] mb-2" data-id="element-465">
            SE LLAMA
          </span>
          <h3 className="relative z-10 font-serif font-black text-5xl md:text-7xl text-cream tracking-tight mb-4" data-id="element-466">
            GLICACIÓN
          </h3>
          <p className="relative z-10 font-sans text-cream/80 text-sm md:text-base max-w-md mx-auto" data-id="element-467">
            Es una reacción química real. La ciencia lleva décadas
            documentándola.
          </p>
        </div>

        {/* Organ Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-16" data-id="element-468">
          {organs.map((organ, idx) => <div key={idx} className="bg-dark-card rounded-lg p-6 text-center border border-border-subtle hover:border-gold/30 transition-colors" data-id="element-469">
              <div className="text-4xl mb-4" data-id="element-470">{organ.icon}</div>
              <h4 className="font-serif text-gold text-sm font-bold mb-2" data-id="element-471">
                {organ.name}
              </h4>
              <p className="font-sans text-gray-warm text-[12px] leading-snug" data-id="element-472">
                {organ.desc}
              </p>
            </div>)}
        </div>

        {/* Bottom Callout */}
        <div className="bg-dark-card border-l-[4px] border-red rounded-r-lg p-6 md:p-8 max-w-2xl mx-auto" data-id="element-473">
          <p className="font-sans text-cream text-[16px] md:text-[18px] leading-relaxed" data-id="element-474">
            <span className="font-bold text-red" data-id="element-475">Y hay algo más:</span> tu
            glucosa puede subir aunque no hayas comido nada dulce. El estrés, el
            mal sueño, la ansiedad — todo eso activa una respuesta que libera
            glucosa al torrente sanguíneo sin que comas nada.
          </p>
        </div>
      </div>
    </section>;
}